import {PromoCards} from '@frontend/modules/layout/promo_cards/PromoCards'
import type {CabinetMenuType} from '@frontend/modules/private/shared/CabinetSharedTypes'
import type {ReactNode} from 'react'
import {CabinetFinancesMenu} from './CabinetFinancesMenu'
import {CabinetProfileInfoMenu} from './CabinetProfileInfoMenu'

interface Props {
    type: CabinetMenuType
}

// Меню для ЛК.
export function CabinetMenu(props: Props) {

    const {
        type,
    } = props

    let menu: ReactNode | null = null
    switch (type) {
        case 'finances':
            menu = <CabinetFinancesMenu key="finances" />
            break
        case 'profile':
            menu = <CabinetProfileInfoMenu />
            break
        default:
            return null
    }

    return (
        <div id="cabinet-sidebar-container">
            <div className="cabinet-side-menu mb-3 mb-xl-0">
                {menu}
            </div>
            <PromoCards
                className="mt-4 d-none d-lg-grid"
                utmSource="cabinet_side_menu"
            />
        </div>
    )
}
